import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 60px auto;
  border-top: 1px solid #ddd;
`;

export const Content = styled.div`
  width: 80%;
  margin: 0 auto;
  p {
    color: #ff4400;
    text-align: center;
    margin-top: 40px;
  }
  h3 {
    margin-top: 30px;
    text-align: center;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      font-weight: bold;
      color: #74a50a;
    }
  }
  h3.error {
    margin-top: 30px;
    text-align: center;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      font-weight: bold;
      color: #cc0000;
    }
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin: 40px auto;
  input {
    width: 100%;
    padding: 10px 15px;
    min-height: 32px;
    border-radius: 3px;
    border: solid 0.5px #c7c7c7;
    background-color: #eaeaea;
    font-size: 12px;
    color: #a3a3a3;
  }
  .error {
    color: #cc0000;
    border-radius: 3px;
    border: solid 0.5px #cc0000;
    background-color: rgba(204, 0, 0, 0.16);
  }
`;

export const TitleSection = styled.h4`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: 0.01px;
  text-align: left;
  color: #74a50a;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  width: 100%;
  min-height: 90px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
  align-items: flex-end;
`;
export const Col = styled.div`
  width: 45%;
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 8px;
  display: block;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 15px;
  min-height: 32px;
  border-radius: 3px;
  border: solid 0.5px #ff4400;
  background-color: #eaeaea;
  font-size: 12px;
  color: #a3a3a3;
`;
